// @ts-nocheck
import { MOCK, invalidateAndRefresh } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { api, adminApi } from "@/api/index";

const { $, $$, fmtNum, fmtMoney, fmtPercent, toast, confirmModal, hasPerm, statusBadge, trendArrow, statCard, channelChip, capabilityBadge, pageHeader, emptyState, primaryBtn, ghostBtn, stepIndicator, BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries } = UI;

declare const echarts: any;
declare const Pages: Record<string, any>;
declare const PageHooks: { mounted?: ((path: string) => void) | null };
declare function navigate(path: string): void;
declare function getCurrentPath(): string;
declare function getCurrentPathWithQuery(): string;
declare function renderRoute(): void;

if (typeof window !== "undefined") {
  (window as any).Pages = (window as any).Pages || {};
}

const Pages = (window as any).Pages;

// ============================================================
// 管理员功能 · 渠道管理（Channel Manager）
// 平台级管理所有渠道、查看接入状态、调整 Adapter 配置
// ============================================================

window.Pages = window.Pages || {};

Pages.channelMgr = function () {
  if (!UI.hasPerm("admin")) {
    return UI.emptyState({ icon: "🔒", title: "权限不足", desc: "仅 SDK 管理员可访问" });
  }

  const cats = [
    { code: "social", name: "社交网络" },
    { code: "messaging", name: "即时通讯" },
    { code: "community", name: "社区论坛" },
  ];

  return `
    ${UI.pageHeader({
      title: "渠道能力中心",
      desc: "平台级维护渠道启用状态、能力声明、Adapter 字段与最低接入要求",
      actions: `<button onclick="UI.toast('请填写新渠道接入申请', 'info')" class="px-3 py-1.5 text-sm bg-brand-500 text-white rounded-lg hover:bg-brand-600">+ 新增渠道</button>`,
    })}

    <!-- 渠道总览 -->
    <div class="grid grid-cols-4 gap-4 mb-4">
      ${UI.statCard({ label: "支持渠道", value: MOCK.CHANNELS.length, delta: 0, icon: "globe", color: "brand" })}
      ${UI.statCard({ label: "已启用", value: MOCK.CHANNELS.filter((c) => c.enabled).length, delta: 0, icon: "check", color: "green" })}
      ${UI.statCard({ label: "Adapter 实现", value: 8, delta: 0, icon: "code", color: "blue" })}
      ${UI.statCard({ label: "字段定义", value: MOCK.CHANNELS.reduce((sum, c) => sum + c.standard_fields.length + c.custom_fields.length, 0), delta: 0, icon: "database", color: "amber" })}
    </div>

    <!-- 平台能力矩阵（核心：来自渠道字段文档 P2） -->
    <div class="card mb-4 overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100">
        <h3 class="text-sm font-semibold text-ink-900">📊 平台能力矩阵</h3>
        <p class="text-xs text-ink-500 mt-0.5">不同渠道的能力差异，决定各 Adapter 的 platform_overrides 字段范围</p>
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-4 py-2.5 font-medium">渠道</th>
            <th class="text-left px-4 py-2.5 font-medium">分类</th>
            <th class="text-center px-4 py-2.5 font-medium">私聊 DM</th>
            <th class="text-center px-4 py-2.5 font-medium">群聊</th>
            <th class="text-left px-4 py-2.5 font-medium">卡片协议</th>
            <th class="text-center px-4 py-2.5 font-medium">富媒体</th>
            <th class="text-center px-4 py-2.5 font-medium">字段数</th>
            <th class="text-center px-4 py-2.5 font-medium">状态</th>
            <th class="text-right px-4 py-2.5 font-medium">操作</th>
          </tr>
        </thead>
        <tbody>
          ${MOCK.CHANNELS.map((c) => `
            <tr class="border-t border-ink-100 row-hover">
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <span class="text-base">${c.icon}</span>
                  <span class="font-medium">${c.name}</span>
                </div>
              </td>
              <td class="px-4 py-3"><span class="badge bg-ink-50 text-ink-700">${c.category_name}</span></td>
              <td class="px-4 py-3 text-center">${UI.capabilityBadge(c.capabilities.dm)}</td>
              <td class="px-4 py-3 text-center">${UI.capabilityBadge(c.capabilities.group)}</td>
              <td class="px-4 py-3 font-mono text-xs">${c.capabilities.card}</td>
              <td class="px-4 py-3 text-center">
                <span class="badge ${c.capabilities.richMedia === "很强" ? "bg-emerald-100 text-emerald-700" : c.capabilities.richMedia === "强" ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}">${c.capabilities.richMedia}</span>
              </td>
              <td class="px-4 py-3 text-center text-ink-700">${c.standard_fields.length + c.custom_fields.length}</td>
              <td class="px-4 py-3 text-center">
                <label class="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" ${c.enabled ? "checked" : ""} class="sr-only peer" onchange="toggleChannelEnabled('${c.code}', this.checked)" />
                  <div class="w-9 h-5 bg-ink-100 peer-checked:bg-brand-500 rounded-full transition relative">
                    <div class="absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full peer-checked:translate-x-4 transition shadow"></div>
                  </div>
                </label>
              </td>
              <td class="px-4 py-3 text-right">
                <button onclick="navigate('/admin/channels/${c.code}')" class="text-xs text-brand-500 hover:underline">详情</button>
              </td>
            </tr>
          `).join("")}
        </tbody>
      </table>
    </div>

    <!-- 痛点提醒 -->
    <div class="bg-amber-50 border border-amber-200 rounded-xl p-4">
      <div class="text-sm font-semibold text-amber-900 mb-2 flex items-center gap-2">
        ⚠️ 渠道接入运营痛点（来自实战经验）
      </div>
      <div class="grid grid-cols-2 gap-3 mt-2">
        ${[
          { issue: "crawler 缓存", severity: "极高", desc: "Facebook 等爬虫缓存 OG meta，修改后不刷新" },
          { issue: "图片不刷新", severity: "极高", desc: "图片 URL 被 CDN 缓存，需带版本号" },
          { issue: "deep link 失败", severity: "极高", desc: "各 App schema/UniversalLink/AppLink 失效" },
          { issue: "iOS schema 拦截", severity: "高", desc: "iOS 14+ 对自定义 URL Scheme 限制" },
          { issue: "Android intent 兼容", severity: "高", desc: "不同 Android 版本/厂商行为差异" },
          { issue: "WhatsApp 缓存 24h+", severity: "高", desc: "WA 的 OG 缓存最长 24 小时无官方刷新接口" },
        ].map((i) => `
          <div class="bg-white rounded-lg p-3 border border-amber-100">
            <div class="flex items-center justify-between">
              <span class="text-sm font-medium text-amber-900">${i.issue}</span>
              <span class="badge ${i.severity === "极高" ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-700"}">${i.severity}</span>
            </div>
            <div class="text-xs text-amber-800 mt-1">${i.desc}</div>
          </div>
        `).join("")}
      </div>
    </div>
  `;
};

// ---------- 渠道详情：Adapter 字段定义 + 接入文档 + 实时数据 ----------
Pages.channelDetail = function (channelCode) {
  if (!UI.hasPerm("admin")) {
    return UI.emptyState({ icon: "🔒", title: "权限不足" });
  }
  const c = MOCK.CHANNELS.find((x) => x.code === channelCode);
  if (!c) return UI.emptyState({ icon: "🔍", title: "渠道不存在" });

  const stat = MOCK.CHANNEL_COMPARE.find((x) => x.code === channelCode);

  return `
    ${UI.pageHeader({
      title: `${c.icon} ${c.name}`,
      desc: `${c.category_name} · Adapter：${c.name}Adapter.ts · 当前状态：${c.enabled ? "已启用" : "未启用"}`,
      actions: `
        <button onclick="navigate('/admin/platform/channels')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回列表</button>
        <button onclick="confirmAction('保存渠道配置', '确定要保存当前渠道配置吗？保存后会影响后续渠道适配与分享参数。', '确认保存', '已保存渠道配置')" class="px-3 py-1.5 text-sm bg-brand-500 text-white rounded-lg hover:bg-brand-600">保存修改</button>
      `,
    })}

    <!-- 实时数据 -->
    ${
      stat
        ? `
    <div class="grid grid-cols-4 gap-3 mb-4">
      ${UI.statCard({ label: "标准字段", value: c.standard_fields.length, delta: 0, icon: "database", color: "brand" })}
      ${UI.statCard({ label: "渠道特有字段", value: c.custom_fields.length, delta: 0, icon: "filter", color: "blue" })}
      ${UI.statCard({ label: "能力项", value: 4, delta: 0, icon: "check", color: "green" })}
      ${UI.statCard({ label: "最低 SDK", value: "v2.4", delta: 0, icon: "package", color: "amber" })}
    </div>`
        : ""
    }

    <div class="grid grid-cols-3 gap-4">
      <!-- 左：能力 + 字段 -->
      <div class="col-span-2 space-y-4">
        <div class="card p-5">
          <h3 class="text-sm font-semibold text-ink-900 mb-3">⚡️ 渠道能力声明</h3>
          <div class="grid grid-cols-4 gap-3">
            <div class="bg-ink-50 rounded-lg p-3 text-center">
              <div class="text-xs text-ink-500">私聊 DM</div>
              <div class="text-base font-semibold mt-1">${UI.capabilityBadge(c.capabilities.dm)}</div>
            </div>
            <div class="bg-ink-50 rounded-lg p-3 text-center">
              <div class="text-xs text-ink-500">群聊</div>
              <div class="text-base font-semibold mt-1">${UI.capabilityBadge(c.capabilities.group)}</div>
            </div>
            <div class="bg-ink-50 rounded-lg p-3 text-center">
              <div class="text-xs text-ink-500">卡片协议</div>
              <div class="text-xs font-mono mt-1 text-ink-700">${c.capabilities.card}</div>
            </div>
            <div class="bg-ink-50 rounded-lg p-3 text-center">
              <div class="text-xs text-ink-500">富媒体</div>
              <div class="text-base font-semibold mt-1 ${c.capabilities.richMedia === "很强" ? "text-emerald-600" : c.capabilities.richMedia === "强" ? "text-emerald-500" : "text-amber-500"}">${c.capabilities.richMedia}</div>
            </div>
          </div>
        </div>

        <div class="card p-5">
          <h3 class="text-sm font-semibold text-ink-900 mb-3">🧩 Adapter 字段定义</h3>
          <div class="grid grid-cols-2 gap-4">
            <div>
              <div class="text-xs font-semibold text-ink-700 mb-2 flex items-center gap-1">
                <span class="px-1.5 py-0.5 bg-blue-100 text-blue-700 text-[10px] rounded">标准字段</span>
                UTM 追踪
              </div>
              <div class="space-y-1.5">
                ${c.standard_fields.map((f) => `
                  <div class="flex items-center gap-2 px-2 py-1.5 bg-ink-50 rounded font-mono text-xs">
                    <code class="text-brand-600">${f}</code>
                    <span class="ml-auto text-ink-300 text-[10px]">string</span>
                  </div>
                `).join("")}
              </div>
            </div>
            <div>
              <div class="text-xs font-semibold text-ink-700 mb-2 flex items-center gap-1">
                <span class="px-1.5 py-0.5 bg-purple-100 text-purple-700 text-[10px] rounded">渠道特有</span>
                platform_overrides.${c.code}
              </div>
              <div class="space-y-1.5">
                ${c.custom_fields.map((f) => `
                  <div class="flex items-center gap-2 px-2 py-1.5 bg-ink-50 rounded font-mono text-xs">
                    <code class="text-purple-600">${f}</code>
                    <span class="ml-auto text-ink-300 text-[10px]">string</span>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
        </div>

        <!-- Adapter 代码片段 -->
        <div class="card p-5">
          <h3 class="text-sm font-semibold text-ink-900 mb-3">💻 Adapter 实现示例</h3>
          <div class="bg-ink-900 rounded-lg overflow-hidden">
            <div class="flex items-center justify-between px-4 py-2 bg-ink-700/50">
              <span class="text-xs text-ink-100 font-mono">${c.name}Adapter.ts</span>
              <button class="text-xs text-ink-300 hover:text-white">📋 复制</button>
            </div>
            <pre class="p-4 text-xs text-ink-100 font-mono overflow-x-auto leading-relaxed"><code><span class="text-purple-300">export class</span> <span class="text-yellow-200">${c.name.replace(/[^a-zA-Z]/g, "")}Adapter</span> <span class="text-purple-300">implements</span> <span class="text-yellow-200">ChannelAdapter</span> {
  <span class="text-cyan-300">readonly</span> code = <span class="text-emerald-300">"${c.code}"</span>;
  <span class="text-cyan-300">readonly</span> capabilities = ${JSON.stringify(c.capabilities, null, 2).split("\n").join("\n  ")};

  <span class="text-purple-300">async</span> share(content: ShareContent): <span class="text-yellow-200">Promise</span>&lt;ShareResult&gt; {
    <span class="text-ink-300">// 1. 翻译 ShareContent → ${c.name} 特定调用</span>
    <span class="text-purple-300">const</span> payload = {
      title: content.title,
      url: <span class="text-purple-300">this</span>.buildTargetURL(content),
      ...content.platform_overrides?.<span class="text-emerald-300">${c.code}</span>,
    };
    <span class="text-purple-300">return</span> <span class="text-purple-300">await</span> <span class="text-purple-300">this</span>.invoke${c.name.replace(/[^a-zA-Z]/g, "")}SDK(payload);
  }
}</code></pre>
          </div>
        </div>
      </div>

      <!-- 右：接入信息 + 文档 -->
      <div class="space-y-4">
        <div class="card p-5">
          <h3 class="text-sm font-semibold text-ink-900 mb-3">📦 接入信息</h3>
          <div class="space-y-2 text-xs">
            <div class="flex items-center justify-between"><span class="text-ink-500">渠道代码</span><code class="font-mono">${c.code}</code></div>
            <div class="flex items-center justify-between"><span class="text-ink-500">分类</span><span>${c.category_name}</span></div>
            <div class="flex items-center justify-between"><span class="text-ink-500">Adapter</span><code class="font-mono">${c.name}Adapter</code></div>
            <div class="flex items-center justify-between"><span class="text-ink-500">SDK 最低版本</span><span class="font-mono">v2.3.0+</span></div>
            <div class="flex items-center justify-between"><span class="text-ink-500">字段总数</span><span>${c.standard_fields.length + c.custom_fields.length}</span></div>
            <div class="flex items-center justify-between"><span class="text-ink-500">接入游戏数</span><span class="font-semibold">${Math.floor(Math.random() * 4) + 1}</span></div>
            <div class="flex items-center justify-between"><span class="text-ink-500">状态</span>${c.enabled ? '<span class="badge bg-emerald-50 text-emerald-700">已启用</span>' : '<span class="badge bg-ink-100 text-ink-500">未启用</span>'}</div>
          </div>
        </div>

        <div class="card p-5">
          <h3 class="text-sm font-semibold text-ink-900 mb-3">⚠️ 已知问题</h3>
          <div class="space-y-2 text-xs">
            ${getChannelIssues(c.code).map((p) => `
              <div class="bg-${p.color}-50 border-l-2 border-${p.color}-400 px-2 py-2 rounded-r">
                <div class="font-medium text-${p.color}-900">${p.title}</div>
                <div class="text-${p.color}-700 mt-0.5">${p.desc}</div>
              </div>
            `).join("")}
          </div>
        </div>

        <div class="card p-5">
          <h3 class="text-sm font-semibold text-ink-900 mb-3">🔗 相关链接</h3>
          <div class="space-y-1.5 text-xs">
            <a href="#" class="block text-brand-500 hover:underline">📖 接入文档</a>
            <a href="#" class="block text-brand-500 hover:underline">🧪 调试工具</a>
            <a href="#" class="block text-brand-500 hover:underline">📊 数据看板</a>
            <a href="#" class="block text-brand-500 hover:underline">🐞 问题追踪</a>
          </div>
        </div>
      </div>
    </div>
  `;
};

function getChannelIssues(code) {
  const m = {
    facebook: [{ title: "Crawler 缓存", desc: "OG meta 修改后不立即刷新，需手动调用 Sharing Debugger", color: "amber" }],
    whatsapp: [{ title: "缓存 24h+", desc: "无官方刷新 API，建议落地页 URL 带版本号", color: "red" }],
    twitter: [{ title: "群聊降级", desc: "DM Group 支持有限，部分场景自动降级单聊", color: "amber" }],
    telegram: [{ title: "instant view 配置", desc: "需要单独提交模板审核才能启用", color: "blue" }],
  };
  return m[code] || [{ title: "暂无已知问题", desc: "—", color: "ink" }];
}

window.toggleChannelEnabled = async function (code, enabled) {
  try {
    await adminApi.updateChannel(code, { enabled: !!enabled });
    await invalidateAndRefresh();
    UI.toast(enabled ? `已启用 ${code}` : `已停用 ${code}`, "success");
  } catch (err) {
    UI.toast(err?.message || "更新渠道失败", "error");
    renderRoute();
  }
};

// __window_exports__
// Expose helpers for cross-page / inline onclick compatibility
;(window as any).getChannelIssues = getChannelIssues;
;(window as any).toggleChannelEnabled = window.toggleChannelEnabled;
